import IdListDTO from '../IdListDTO';
import AuditTrailDTO from '../auditTrailDTO';
import KPIDataDTO from '../kpi/kpiDataDTO';
import LanguageDTO from '../languageDTO';
import TaskTypeDTO from './taskTypeDTO';
import { TaskRelationDTO } from './taskRelationDTO';

export class TaskStateDTO {
  taskStateId: number;

  completed: boolean;

  sortOrder: number;

  taskCount?: number;

  trans: TaskState_TranslationDTO[];

  constructor() {
    this.taskStateId = 0;
    this.completed = false;
    this.sortOrder = 0;
    this.trans = [];
  }
}

export class TaskState_TranslationDTO {
  state: string;

  lang?: LanguageDTO;

  constructor() {
    this.state = '';
  }
}

export class ControlTaskDTO {
  controlId: number;

  taskId: number;

  constructor() {
    this.controlId = 0;
    this.taskId = 0;
  }
}

export default class TaskDTO {
  taskId: number;

  taskMasterId: number | undefined;

  authSchemaId?: number;

  name: string;

  description?: string;

  taskStateId: number;

  taskType: number;

  taskTypeId?: number;

  taskTypeFamilyId?: number;

  formVersion?: TaskTypeDTO;

  sortOrder: number;

  creatorId: string;

  created: string;

  completed?: string;

  userId?: string;

  ownerId: string;

  commentTrailId: number;

  commentCount?: number;

  auditTrailId: number;

  duration: number;

  startDateTime: string;

  endDateTime: string;

  checkList?: string;

  eventId?: string;

  hasFollowUp?: boolean;

  followUpTotal?: number;

  followUpCompleted?: number;

  hasUnlinkedFollowUp?: boolean;

  recurringPattern?: string;

  recurringPatternSummary?: string;

  deadline?: string;

  controlIds?: IdListDTO;

  themeIds?: IdListDTO;

  processIds?: IdListDTO;

  objectiveIds?: IdListDTO;

  assetIds?: IdListDTO;

  riskIds?: IdListDTO;

  normIds?: IdListDTO;

  processingActivityIds?: IdListDTO;

  instances?: TaskDTO[];

  instancesEnabled?: boolean;

  approved?: boolean | undefined;

  hidden?: boolean;

  webhookStatus?: number;

  templateId?: number;

  // read-only: the audit this task is the execution work of (see the API TaskDTO). A finding does
  // not carry it - a finding follows up on the work, it is not the work
  internalAuditId?: number;

  // read-only: the kind the server stamped when the task was created (BaseTask.TaskKinds, see TaskKinds);
  // the server ignores a posted value
  taskKind?: number;

  taskRelations?: TaskRelationDTO[];

  tagIds?: IdListDTO;

  resourceLinkIds?: IdListDTO;

  auditTrail?: AuditTrailDTO;

  kpiData?: KPIDataDTO[];

  externalId?: string;

  constructor() {
    this.taskId = 0;
    this.taskMasterId = 0;
    this.name = '';
    this.taskStateId = 0;
    this.sortOrder = 0;
    this.creatorId = '';
    this.ownerId = '';
    this.created = '';
    this.commentTrailId = 0;
    this.auditTrailId = 0;
    this.startDateTime = '';
    this.endDateTime = '';
    this.duration = 8;
    this.taskType = 0;
    this.taskTypeId = 0;
  }
}
